import { FETCH_ESHOP_HEADER_DATA_SUCCESS, IS_ESHOP_NAVANDSEARCH, FETCH_ESHOP_HEADER_DATA_ERROR, IS_NOT_CANOPY, SET_ESHOP_KW, } from './actionTypes';
import { DataForEshopHeaderApiFactory } from '../services/eshop-header-api/codegenClient';
export const loadEshopHeaderData = (axiosInstance, eshopSellerLogin, basePath) => (dispatch) => {
    return DataForEshopHeaderApiFactory(undefined, basePath, axiosInstance)
        .getEshopHeaderData(eshopSellerLogin)
        .then((result) => {
        const { data } = result;
        dispatch({
            type: FETCH_ESHOP_HEADER_DATA_SUCCESS,
            payload: data,
        });
    })
        .catch((err) => {
        dispatch({
            type: FETCH_ESHOP_HEADER_DATA_ERROR,
            payload: err.response ? { status: err.response.status, statusText: err.response.statusText } : err,
        });
    });
};
export const isEshopNavAndSearch = (payload) => (dispatch) => {
    return dispatch({
        type: IS_ESHOP_NAVANDSEARCH,
        payload: { isEshopNavAndSearch: payload },
    });
};
export const isNotCanopyFn = (payload) => (dispatch) => {
    return dispatch({
        type: IS_NOT_CANOPY,
        payload: { isNotCanopy: payload },
    });
};
export const setKw = (payload) => (dispatch) => {
    return dispatch({
        type: SET_ESHOP_KW,
        payload: { kw: payload },
    });
};
